// account-cabinet-self-progress-my-tabs.simple.js
const DATA_ATTR = 'data-account-cabinet-self-progress-my';
const CLASS_PREFIX = 'account-cabinet-self-progress-my';
import axios from 'axios';

export function initPersonalAccountTabProgressMy($container) {
    const $templateMain = document.querySelector(`[${DATA_ATTR}-template-main]`);
    const $templateProgressCard = document.querySelector(`[${DATA_ATTR}-template-card]`);
    const $templateProgressCardStat = document.querySelector(`[${DATA_ATTR}-template-card-stat]`);
    const $templateProgressCardTag = document.querySelector(`[${DATA_ATTR}-template-card-tag]`);
    const $templateStatCard = document.querySelector(`[${DATA_ATTR}-template-progress]`);

    let $templateStatList = null;
    let $mainFragment = null;
    let $progressCardList = null;
    let $globalProgressTime = null;
    let $globalProgressTimeSum = null;
    let $globalProgressBar = null;
    let $notificationPanel = null;
    let $navTabs = null;


    let dataStat = {
        demands: [],
        tags: [],
        exercise_types: [],
    }
    let initialType = null;

    init();

    async function init() {
        console.log('initPersonalAccountTabProgressMy')
        await renderMain();
        document.dispatchEvent(new CustomEvent('account-cabinet:render-complete', {bubbles: true}));
        await fetchStats("month");
    }


    function getYearMonth() {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Europe/Moscow',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        }).formatToParts(new Date());

        const yearPart = parts.find(p => p.type === 'year');
        const monthPart = parts.find(p => p.type === 'month');

        return {
            year: yearPart ? parseInt(yearPart.value, 10) : new Date().getFullYear(),
            month: monthPart ? parseInt(monthPart.value, 10) : (new Date().getMonth() + 1)
        };
    }

    async function renderMain() {
        $mainFragment = $templateMain.content.cloneNode(true);
        $progressCardList = $mainFragment.querySelector(`[${DATA_ATTR}-progress-list]`);
        $templateStatList = $mainFragment.querySelector(`[${DATA_ATTR}-stat-list]`);
        $globalProgressTime = $mainFragment.querySelector(`[${DATA_ATTR}-global-time]`);
        $globalProgressTimeSum = $mainFragment.querySelector(`[${DATA_ATTR}-global-time-sum]`);
        $globalProgressBar = $mainFragment.querySelector(`[${DATA_ATTR}-global-progress]`);
        $notificationPanel = $mainFragment.querySelector(`[${DATA_ATTR}-notification-panel]`);
        $navTabs = $mainFragment.querySelectorAll(`[${DATA_ATTR}-stat-nav-item]`);

        console.log('TABS', $navTabs)
        $navTabs.forEach($tab => {
            // ensure dataset.type exists
            const type = $tab.dataset.type || $tab.getAttribute('data-type');
            // normalize click handling
            $tab.addEventListener('click', () => {
                console.log('aaaaaaaa')
                // toggle active class
                $navTabs.forEach(t => t.classList.remove(`${CLASS_PREFIX}__stat-nav-item--active`));
                $tab.classList.add(`${CLASS_PREFIX}__stat-nav-item--active`);
                fetchStats(type);
            });

            if ($tab.classList.contains(`${CLASS_PREFIX}__stat-nav-item--active`) && !initialType) {
                initialType = type;
            }
        });

        $container.appendChild($mainFragment);

        document.dispatchEvent(new CustomEvent('account-cabinet:render-complete', {bubbles: true}));
    }

    async function fetchStats(dateType = 'all') {

        const params = {};

        if (dateType === 'month') {
            const { year, month } = getYearMonth();
            params.period = 'month';
            params.year = year;
            params.month = month;
        } else {
            params.period = 'all';
        }

        try {
            const response = await axios.get('/api/user/profile/stat', { params });
            console.log('USER STAT: ', response.data);
            dataStat = response.data;


            await renderGlobalStat();
            await renderProgressList();

        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    }


    function renderGlobalStat() {
        $templateStatList.innerHTML = '';

        $globalProgressTime.textContent = dataStat.user_practice_min || '0';
        $globalProgressTimeSum.textContent = dataStat.total_practice_min || '0';
        $globalProgressBar.setAttribute('value', dataStat.overall_completion_percent);
        if (dataStat.overall_completion_percent < 100) {
            //$notificationPanel.style.display = 'none';
        }

        renderGlobalStatCard($templateStatList, dataStat.demands.summary, 'Запросы');
        renderGlobalStatCard($templateStatList, dataStat.tags.summary, 'Подходы');
        renderGlobalStatCard($templateStatList, dataStat.exercise_types.summary, 'Навыки');
    }


    function renderGlobalStatCard($statContainer, data, title) {
        const $globalStatCard = $templateStatCard.content.cloneNode(true);
        const $progressCardStatTime = $globalStatCard.querySelector(`[${DATA_ATTR}-time]`);
        const $progressCardStatTimeTotal = $globalStatCard.querySelector(`[${DATA_ATTR}-time-total]`);
        const $progressCardStatLabel = $globalStatCard.querySelector(`[${DATA_ATTR}-label]`);
        const $dotsContainer = $globalStatCard.querySelector(`[${DATA_ATTR}-dots]`);

        $progressCardStatTime.textContent = data.user_total_min || '0';
        $progressCardStatTimeTotal.textContent = data.total_min ? data.total_min + ' ч.' : '0 ч.';
        $progressCardStatLabel.textContent = title || '—';

        renderProgressbarDots($dotsContainer, data.user_share_percent, CLASS_PREFIX);

        $statContainer.appendChild($globalStatCard);
    }

    function renderProgressbarDots($dotsContainer, percentRaw = 0, classPrefix = '') {
        if (!$dotsContainer) return;

        const percent = Math.min(100, Math.max(0, Number(percentRaw) || 0));
        const dots = Array.from($dotsContainer.querySelectorAll(`.${classPrefix}__stat-dot`));
        const totalDots = dots.length || 10;
        const perDot = 100 / totalDots;

        const fullCount = Math.floor(percent / perDot);
        const hasPartial = percent % perDot > 0;

        dots.forEach((dot, index) => {
            dot.classList.remove(`${classPrefix}__stat-dot--fill`, `${classPrefix}__stat-dot--empty`);

            if (index < fullCount) {
                // Полностью заполненные точки
                dot.classList.add(`${classPrefix}__stat-dot--fill`);
            } else if (index === fullCount && hasPartial) {
                // Частичная — оставляем базовый .__stat-dot без модификатора
            } else {
                // Пустые
                dot.classList.add(`${classPrefix}__stat-dot--empty`);
            }
        });
    }

    function renderProgressList() {
        $progressCardList.innerHTML = '';

        renderProgressCard(dataStat.demands.items, 'Мои запросы', 'demands');
        renderProgressCard(dataStat.tags.items, 'Мои подходы', 'tags');
        renderProgressCard(dataStat.exercise_types.items, 'Мои навыки', 'exercise');
    }

    function renderProgressCard(dataList, title, type) {
        const $progressCard = $templateProgressCard.content.cloneNode(true);
        const $progressCardTitle = $progressCard.querySelector(`[${DATA_ATTR}-title]`);
        const $progressCardStatList = $progressCard.querySelector(`[${DATA_ATTR}-stat-list]`);

        $progressCardTitle.textContent = title || '—';
        console.log(dataList)
        dataList.forEach((item) => {
            renderProgressCardStat(item, $progressCardStatList, type);
        })

        $progressCardList.appendChild($progressCard);
    }

    function renderProgressCardStat(data, $statContainer, type) {
        if (data.user_duration_minutes == 0) return;
        const $progressCardStat = $templateProgressCardStat.content.cloneNode(true);
        const $progressCardStatTime = $progressCardStat.querySelector(`[${DATA_ATTR}-time]`);
        const $progressCardStatLabel = $progressCardStat.querySelector(`[${DATA_ATTR}-label]`);
        const $progressCardStatProgress = $progressCardStat.querySelector(`[${DATA_ATTR}-progress]`);

        $progressCardStatTime.textContent = data.user_duration || '0 м.';
        $progressCardStatLabel.textContent = data.name || '—';
        $progressCardStatProgress.style.width = data.completion_percent ? data.completion_percent + '%' : '0%';
        $progressCardStatProgress.classList.add(`${CLASS_PREFIX}__card-item-progress-fill--${type}`);

        $statContainer.appendChild($progressCardStat);
    }

}
